import AppHelper from 'helpers/AppHelper';
import useStyles from './style';
import { DialogContent, DialogContentText, DialogActions } from '@material-ui/core';
import ActionButton from 'routing/AppInfoPage/TermsAndConditions/components/ActionButton';

interface SetupStripeProps {
    setStep?: (step: number) => void;
};

export const SetupStripe = (props: SetupStripeProps) => {
    const classes = useStyles();
    
    const onHandleCloseModal = () => {
        AppHelper.hideGlobalModal();
    };

    const onConfirmClicked = (e: any) => {
        e.preventDefault();
        const url = `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${process.env.REACT_APP_STRIPE_CONNECT_ID}&scope=read_write&redirect_uri=${process.env.REACT_APP_DOMAIN}/app-info`;
        window.location.replace(url);
        AppHelper.hideGlobalModal();
    };

    const onCancelClicked = (e: any) => {
        e.preventDefault();
        AppHelper.hideGlobalModal();
    };

    return(
        <>
        <DialogContent>
        <div className={classes.titleDialog}>
          <h3>Stripe setup</h3>
          <span
            onClick={onHandleCloseModal}
            className={classes.iconClose}
          >
            <img src="/images/close.svg" alt="" />
          </span>
        </div>
        <DialogContentText id="alert-dialog-description">
          <span className={classes.contentDialog}>To receive payments through Briklo, you must log in or create your stripe account.</span>
        </DialogContentText>
      </DialogContent>

      <DialogActions className={classes.buttonContainer}>
        <ActionButton
          bgColor="#D2D2D2"
          label="Cancel"
          handleClose={onHandleCloseModal}
        />
        <ActionButton
          bgColor="#0C85F4"
          textColor="#FFFFFF"
          label="Continue"
          handleClose={onConfirmClicked}
          isNext={true}
        />
      </DialogActions>
        </>
    );
};